import CacheEnum from '@/enums/cacheEnum';
import { useLocalStorage } from '@/hooks/useStorage';
import { getBulkListApi } from '@/services/api/requestApi';
import { useReq } from '@/services/net/request';
import { useModel } from '@umijs/max';

/**
 * 使用本地存储和远程请求获取本地块交易数据。
 * 该函数初始化并管理本地块交易数据的状态，包括从本地存储获取数据、向服务器发送请求以获取数据列表，
 * 并在获取成功时更新本地存储。
 *
 * @returns 返回一个对象，包含以下方法和状态：
 *  - setLocalBlockTrade: 设置本地块交易数据的方法。
 *  - localBlockTrade: 当前本地块交易数据的状态。
 *  - getBlockTradeListReq: 获取块交易列表请求的方法。
 *  - blockTradeList: 块交易列表的数据状态。
 */
export default () => {
  // 使用本地存储 hook 来管理本地块交易数据
  const [localBlockTrade, setLocalBlockTrade] = useLocalStorage({
    key: CacheEnum.APP_LOCAL_BLOCK_TRADE,
    defaultValue: null,
  });
  // 使用 socket 模型来发送消息
  const { sendMsg } = useModel('socket');

  // 使用请求 hook 来获取块交易列表
  // const { data: blockTradeList = [] as any, runAsync: getBlockTradeListReq } =
  //   useReq(getBulkListApi, {
  //     manual: false,
  //     cacheKey: CacheEnum.PAGE_HOME_BLOCK_TRADE_LIST,
  //     formatResult: (res: any) => {
  //       const { list } = res?.data || [];
  //       return list ?? [];
  //     },
  //     onSuccess: (res: any) => {
  //       if (res?.[0]) {
  //         // 如果本地没有块交易数据，则设置从服务器获取的数据作为本地数据
  //         if (!localBlockTrade) {
  //           setLocalBlockTrade(res[0]);
  //         }
  //         // 发送订阅消息，包含最新的块交易列表的股票符号
  //         const { list } = res || {};
  //         sendMsg(
  //           `{"type":"SUB","data": "${JSON.stringify(
  //             list.map((i: any) => i?.stockInfo?.symbol),
  //           )}"}`,
  //         );
  //       }
  //     },
  //   });

  return {
    setLocalBlockTrade,
    localBlockTrade,
    getBlockTradeListReq:()=>{},
    blockTradeList:[],
  };
};
